<template>
<div class="applyTabDetail">
  <div class="tabDetail-top">
    <div class="iconfont iconzuojiantou jian" @click="toBack"></div>
    <div>查看详情</div>
    <div></div>
  </div>
  <!-- 任务详情 -->
  <div class="tabDetail-content">
    <div class="content-title">
      <div class="twig"></div>
      <div>任务详情</div>
    </div>
    <div class="content-detail">
      <div class="content-detail-left">
        <div class="basic-serve">{{applyInfo.platformDetailDTO.taskName}}</div>
        <div class="city-num">
          <div class="city">{{applyInfo.pTCityPlatformTaskDTO.areaName}}</div>
          <div class="city-twig"></div>
          <div class="num">{{
                applyInfo.platformDetailDTO.peopleNumber == -1
                  ? "人数不限"
                  : applyInfo.platformDetailDTO.peopleNumber + "人"
              }}</div>
        </div>
        <div class="ask">
          <div>{{ genderMap[applyInfo.platformDetailDTO.requirementSex] }}</div>
          <div class="ask-twig"></div>
          <div>{{applyInfo.platformDetailDTO.requirementAgeMin}} -- {{applyInfo.platformDetailDTO.requirementAgeMax}}周岁</div>
          <div class="ask-twig"></div>
          <div>{{eduMap[applyInfo.platformDetailDTO.requirementEducation]}}</div>
        </div>
        <div class="company">{{applyInfo.companyInfoDTO.companyName}}</div>
      </div>
      <div class="content-detail-right">
        <div class="cover-charge">服务费：</div>
        <div class="censure"><span v-if="applyInfo.platformDetailDTO.salaryAsk == 'SECTION'">
                {{ applyInfo.platformDetailDTO.salaryBlockMin }}-{{ applyInfo.platformDetailDTO.salaryBlockMax }}元 /
                {{ applyInfo.platformDetailDTO.salaryUnit }}
              </span>
              <span v-if="applyInfo.platformDetailDTO.salaryAsk == 'DISCUSS'"> 面议 </span>
              <span v-if="!applyInfo.platformDetailDTO.salaryAsk || applyInfo.platformDetailDTO.salaryAsk == 'FIXED'">
                  {{ applyInfo.platformDetailDTO.salarySettlement }}元/{{ applyInfo.platformDetailDTO.salaryUnit }}
              </span></div>
      </div>
    </div>
  </div>
  <!-- 进度详情 -->
  <div class="tabDetail-step">
    <div class="step-title">
      <div class="twig"></div>
      <div>进度详情</div>
    </div>
    <div class="step">
    <div class="step-content" v-for="(item, index) in applyInfo.platformTaskApplyLogDTO" :key="item.id">
      <div class="step-icon">
        <div class="circle-out">
          <div class="circle-in"></div>
        </div>
        <div class="dotted" v-if="index < (applyInfo.platformTaskApplyLogDTO.length - 1)"></div>
      </div>
      <div class="step-status">
        <div class="status">{{item.applyNotes}}</div>
        <div class="time">{{item.createdAt}}</div>
      </div>
    </div>
  </div>
  </div>

</div>

</template>
<script>
export default {
  data(){
    return{
      applyInfo:{
        companyInfoDTO: {},
        pTCityPlatformTaskDTO: {},
        platformDetailDTO: {},
        platformTaskApplyLogDTO: [],
      },
      genderMap: {
        male: "男",
        female: "女",
        unlimited: "不限"
      } ,
      tab:"",
      currentPage:"",
      eduMap: {
        10:"学历不限",
        20:"初中",
        30:"高中",
        40:"专科",
        50:"本科",
        60:"硕士",
        70:"博士"
      },
    }
  },
  mounted(){
    const url = new URL(location.href);
    this.tab=url.searchParams.get('tab');
    this.currentPage=url.searchParams.get('currentPage');
    this.applyInfo=this.$route.params;
    console.log(this.applyInfo)
  } ,
  methods:{
    toBack(){
      this.$router.push({path:'/applyAdmitTab',query:{tab:this.tab,currentPage:this.currentPage}})
    }
  }
}
</script>
<style lang="less" scope>
.applyTabDetail{
  height: 100%;
  background: #f9fafb;
  .tabDetail-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    font-size: 35px;
    .jian{
      font-size: 35px;
    }
  }
  .tabDetail-content{
    padding: 20px;
    .content-title{
      display: flex;
      align-items: center;
      font-size: 32px;
      .twig{
        width: 4px;
        height: 30px;
        background: #1e9def;
        margin-right: 10px;
      }
    }
    .content-detail{
      padding: 40px;
      display: flex;
      justify-content: space-between;
      background: #ffffff;
      .content-detail-left{
        text-align: left;
        .basic-serve{
          font-size: 32px;
        }
        .city-num{
          color: #000;
          display: flex;
          align-items: center;
          .city-twig{
            height: 25px;
            width: 1px;
            background: #000;
            margin: 0 10px;
          }
        }
        .ask{
          display: flex;
          align-items: center;
          color: #6f6f6f;
          margin: 10px 0;
          .ask-twig{
            height: 25px;
            width: 1px;
            background: #6f6f6f;
            margin: 0 10px;
          }
        }
        .company{
          color: #777777;
        }

      }
      .content-detail-right{
        .cover-charge{
          padding-top: 8px;
        }
        display: flex;
        .censure{
          color: #d54f58;
          font-size: 32px;
        }
      }
    }

  }
  .tabDetail-step{
    text-align: left;
    padding: 20px;
    .step-title{
      font-size: 32px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .twig{
        width: 4px;
        height: 30px;
        background: #1e9def;
        margin-right: 10px;

      }

    }
    .step{
      background: #ffffff;
      padding: 20px;
      .step-content{
      display: flex;
      .step-icon{
        margin-right: 20px;
        .circle-out{
          width: 20px;
          height: 20px;
          border:1px solid #6AB3FD;
          border-radius: 50%;
          background: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          .circle-in{
            width: 12px;
            height:12px;
            background: #6AB3FD;
            border-radius: 50%;
          }
        }
        .dotted{
          height: 50px;
          border-left:3px dotted #888888;
          // margin: 5px 0 10px 20px;
          margin: 10px 0 10px 10px;
        }
      }
      .step-status{
        color: #888888;
        padding: 5px 0;
        .status{
          font-size: 26px;
        }
      }
    }

    }

  }

}

</style>



// WEBPACK FOOTER //
// src/pages/applyAdmit/applyTabDetail/index.vue